import { useParams } from "react-router-dom";
import { SparePartsPage } from "./SparePartsPage";

const ProductSparePartsPage: React.FC = () => {
    const {"*": productLink} = useParams<{"*": string }>();
    const productLinkArray = productLink?.split('/');
    const productSlug = productLinkArray?.length ? productLinkArray[productLinkArray.length - 1].split('-') : null;
    const brandSlug = productSlug?.[0];
    const article = productSlug?.[1];
    
    return (
        <SparePartsPage
            initBrandSlug={brandSlug || null}
            initArticle={article || null}
        />
    );
};

export default ProductSparePartsPage;